import { render, staticRenderFns } from "./DisplayDeviceBatteryLevelComponent.vue?vue&type=template&id=cd4958d4&"
import script from "./DisplayDeviceBatteryLevelComponent.vue?vue&type=script&lang=js&"
export * from "./DisplayDeviceBatteryLevelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports